import Link, { LinkProps } from "next/link";

export default function LinkWithoutPrefetch(props: LinkProps) {
    return <Link {...props} prefetch={props.prefetch ?? false} />
}